<template>
    <div class="vx-col md:w-full sm:w-auto text-center">
        <ul class="display-flex justify-content-center ">
            <li>
                <vx-tooltip text="Chi tiết" position="top" color="primary">
                    <feather-icon icon="EditIcon" class="mr-4 text-warning"
                                  svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                  @click="editRecord"/>
                </vx-tooltip>
                <vx-tooltip text="Phê duyệt" position="top" color="primary" v-if="params.data.status == 0">
                    <feather-icon icon="CheckIcon" class="mr-4 text-success"
                                  svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                  @click="confirmAcceptLeave"/>
                </vx-tooltip>
                <vx-tooltip text="Từ chối" position="top" color="primary" v-if="params.data.status == 0">
                    <feather-icon icon="XIcon" class="text-danger"
                                  svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                  @click="confirmRejectLeave"/>
                </vx-tooltip>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'CellRendererActions',
    methods: {
        editRecord() {
            this.$router.push(`/user/remote-timekeeping-info?employeeId=${this.params.data.employeeId}&id=${this.params.data.id}&fullName=${this.params.data.employeeFullname}`).catch(() => {
            })
        },
        confirmAcceptLeave() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: `Xác nhận duyệt`,
                text: `Bạn có chắc chắn muốn duyệt đơn chấm công từ xa của nhân viên "${this.params.data.employeeFullname}" không ? `,
                accept: this.acceptLeave,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },
        acceptLeave() {
            this.$vs.loading();
            let payload = {
                comment: this.params.data.comment,
                employeeId: this.params.data.employeeId,
                endTime: this.params.data.endTimeApprove,
                fullAddress: this.params.data.fullAddress,
                id: this.params.data.id,
                latitude: this.params.data.latitude,
                longitude: this.params.data.longitude,
                name: this.params.data.name,
                organizationBranchId: this.params.data.organizationBranchId,
                organizationId: this.params.data.organizationId,
                reason: this.params.data.reason,
                startTime: this.params.data.startTimeApprove,
                status: this.params.data.status
            };
            payload.status = 1;
            this.$crm.put(`/employee-location-checkin/approve?id=${payload.id}`, payload).then(() => {
                this.$vs.loading.close();
                this.showUpdateSuccess(true);
                this.$store.commit('UPDATE_OVERTIME', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        confirmRejectLeave() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận từ chối`,
                text: `Bạn có chắc là muốn từ chối đơn làm từ xa của nhân viên "${this.params.data.employeeFullname}" không ? `,
                accept: this.acceptCancelLeave,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },
        acceptCancelLeave() {
            this.$vs.loading();
            let payload = {
                comment: this.params.data.comment,
                employeeId: this.params.data.employeeId,
                endTime: this.params.data.endTimeApprove,
                fullAddress: this.params.data.fullAddress,
                id: this.params.data.id,
                latitude: this.params.data.latitude,
                longitude: this.params.data.longitude,
                name: this.params.data.name,
                organizationBranchId: this.params.data.organizationBranchId,
                organizationId: this.params.data.organizationId,
                reason: this.params.data.reason,
                startTime: this.params.data.startTimeApprove,
                status: this.params.data.status
            };
            payload = {
                ...payload,
                status: 2
            }
            this.$crm.put(`/employee-location-checkin/approve?id=${payload.id}`, payload).then(() => {
                this.$vs.loading.close();
                this.showUpdateSuccess(false);
                this.$store.commit('UPDATE_OVERTIME', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error || 'Duyệt đơn làm từ xa thất bại',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showUpdateSuccess(check) {
            this.$vs.notify({
                color: 'success',
                text: check ? 'Duyệt đơn làm từ xa thành công' : 'Từ chối đơn làm từ xa thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    }
}
</script>

<style scoped>


</style>
